import React, { useState, useMemo, useCallback } from 'react';
import LightboxImageStyled from './bundle.esm2.js';
import Modal from '../Modal/bundle.esm.js';
import Image from '../Image/bundle.esm.js';
import Clickable from '../Clickable/bundle.esm.js';
import { defaultFunction } from '../../utils/bundle.esm2.js';
import useIsomorphicLayoutEffect from '../../hooks/bundle.esm.js';
import CrossCircleSVG from '../../assets/images/bundle.esm2.js';
import ArrowLeftSVG from '../../assets/images/carousel/bundle.esm.js';
import ArrowRightSVG from '../../assets/images/carousel/bundle.esm2.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LightboxImage = (props) => {
  const _a = props, {
    className,
    onClose = defaultFunction,
    images,
    imageConfig,
    opened,
    backdropConfig,
    value,
    onChange,
    errorImage
  } = _a, rest = __objRest(_a, [
    "className",
    "onClose",
    "images",
    "imageConfig",
    "opened",
    "backdropConfig",
    "value",
    "onChange",
    "errorImage"
  ]);
  const [internalOpened, setInternalOpened] = useState(true);
  const [internalValue, setInternalValue] = useState(0);
  const show = typeof opened === "undefined" ? internalOpened : opened;
  const actualValue = value != null ? value : internalValue;
  const currentImage = useMemo(() => {
    return images[actualValue];
  }, [images, actualValue]);
  const newBackdropConfig = useMemo(() => {
    return __spreadValues({
      name: "LightboxImage",
      opacity: 0.6
    }, backdropConfig);
  }, [backdropConfig]);
  const closeHandler = () => {
    onClose();
    setInternalOpened(false);
  };
  const previousHandler = useCallback(() => {
    if (actualValue === 0) {
      const newValue2 = images.length - 1;
      onChange == null ? void 0 : onChange(newValue2);
      setInternalValue(newValue2);
      return;
    }
    const newValue = actualValue - 1;
    onChange == null ? void 0 : onChange(newValue);
    setInternalValue(newValue);
  }, [actualValue, images.length, onChange]);
  const nextHandler = useCallback(() => {
    if (actualValue === images.length - 1) {
      onChange == null ? void 0 : onChange(0);
      setInternalValue(0);
      return;
    }
    const newValue = actualValue + 1;
    onChange == null ? void 0 : onChange(newValue);
    setInternalValue(newValue);
  }, [actualValue, images.length, onChange]);
  const keyUpHandler = useCallback(
    (e) => {
      if (!show)
        return;
      if (e.key === "ArrowLeft")
        previousHandler();
      if (e.key === "ArrowRight")
        nextHandler();
    },
    [show, previousHandler, nextHandler]
  );
  useIsomorphicLayoutEffect(() => {
    document.body.addEventListener("keyup", keyUpHandler);
    return () => {
      document.body.removeEventListener("keyup", keyUpHandler);
    };
  }, [keyUpHandler]);
  if (images.length === 0) {
    console.error(
      `${LightboxImage.displayName}: There are no images to display`
    );
    return null;
  } else if (actualValue >= images.length) {
    console.error(
      `${LightboxImage.displayName}: The value ${actualValue} is invalid because there are just ${images.length} images`
    );
  }
  return /* @__PURE__ */ React.createElement(Modal, __spreadProps(__spreadValues({
    backdropConfig: newBackdropConfig,
    closeIcon: /* @__PURE__ */ React.createElement(CrossCircleSVG, null),
    onClose: closeHandler,
    color: "transparent"
  }, rest), {
    opened: show
  }), /* @__PURE__ */ React.createElement(LightboxImageStyled, {
    className: `LightboxImage ${className}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: "LightboxImage__controls"
  }, /* @__PURE__ */ React.createElement(Clickable, {
    onClick: previousHandler
  }, /* @__PURE__ */ React.createElement(ArrowLeftSVG, {
    className: "LightboxImage__icon",
    viewBox: "0 0 6 13"
  })), /* @__PURE__ */ React.createElement(Clickable, {
    onClick: nextHandler
  }, /* @__PURE__ */ React.createElement(ArrowRightSVG, {
    className: "LightboxImage__icon",
    viewBox: "0 0 6 13"
  }))), /* @__PURE__ */ React.createElement(Image, __spreadProps(__spreadValues({
    className: "LightboxImage__image"
  }, imageConfig), {
    image: currentImage,
    errorImage
  }))));
};
LightboxImage.defaultProps = {
  className: "",
  onClose: defaultFunction
};

export { LightboxImage as default };
//# sourceMappingURL=bundle.esm.js.map
